module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-get-started-large.25877155.png";